<script setup lang="ts">
const router = useRouter();

// We have to get the route meta through useRouter because useRoute is not available here
const currentPageCanSSR = computed(() => {
  return router.currentRoute.value.meta.ssr;
});

const isAppInteractive = useIsAppInteractive();
useAuthBroadcastListener();
useSentryReplays({ enabled: isAppInteractive });
useRedirectSoftSuspendedUser({ enabled: isAppInteractive });
const cookieConsentBannerLoaded = useDelayClientLoad(1000);

useHead({
  link: [
    // MatchWornShirt API
    {
      rel: "dns-prefetch",
      href: "https://api.mws.com",
    },
    {
      rel: "preconnect",
      href: "https://api.mws.com",
      crossorigin: "",
    },
  ],
});
</script>

<template>
  <div :data-test="isAppInteractive && 'app-is-interactive'">
    <LayoutPageHead />
    <NuxtLayout>
      <NuxtErrorBoundary>
        <LazyLayoutCookieConsentBanner v-if="cookieConsentBannerLoaded" />
        <NuxtPage v-if="currentPageCanSSR" />
        <ClientOnly v-else>
          <NuxtPage />
          <template #fallback>
            <BaseLoadingSpinner />
          </template>
        </ClientOnly>
        <template #error="{ error, clearError }">
          <LayoutPageError
            :error="error"
            :clear-error="clearError"
          />
        </template>
      </NuxtErrorBoundary>
    </NuxtLayout>
  </div>
</template>
